module.exports = __webpack_public_path__ + "static/media/import.8787fde2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/import.svg
// module id = 589
// module chunks = 0